import { render } from "./SystemVmsTab.vue?vue&type=template&id=5a56584f&scoped=true"
import script from "./SystemVmsTab.vue?vue&type=script&lang=js"
export * from "./SystemVmsTab.vue?vue&type=script&lang=js"

import "./SystemVmsTab.vue?vue&type=style&index=0&id=5a56584f&lang=scss&scoped=true"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a56584f"]])

export default __exports__